module.exports = __webpack_public_path__ + "img/discover4.dd08e69b.png";